import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, AlertTriangle } from "lucide-react";
import { API } from "../config";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

export default function AutoReorderRedeemPage() {
  const { id } = useParams();
  const { user, token, loading: authLoading } = useAuth();
  const { fetchCart } = useCart();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    if (authLoading) return;
    if (!user || !token) {
      navigate(`/login?redirect=${encodeURIComponent(`/auto-reorder/${id}`)}`);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await axios.post(
          `${API}/subscriptions/${id}/redeem`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (cancelled) return;
        await fetchCart();
        navigate("/cart", { replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.detail || "Could not load this Auto-Reorder.");
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authLoading, user, token, id]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center" data-testid="auto-reorder-redeem">
      {error ? (
        <>
          <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-3" />
          <h1 className="text-xl font-bold text-gray-900 mb-2">We couldn't load this Auto-Reorder</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate("/account")}
            className="bg-[#00a99d] hover:bg-[#008c82] text-white font-semibold px-5 py-2.5 rounded-lg"
          >
            Go to My Account
          </button>
        </>
      ) : (
        <>
          <Loader2 className="w-10 h-10 text-[#00a99d] mx-auto mb-3 animate-spin" />
          <h1 className="text-lg font-bold text-gray-900">Loading your Auto-Reorder…</h1>
          <p className="text-sm text-gray-500 mt-2">We're popping your essentials into the cart.</p>
        </>
      )}
    </div>
  );
}
